import { createApiHook } from '../hooks';
import { thirdPartyTagsApiFactory } from './thirdPartyTagsApiFactory';

export const useThirdPartyTagsApi = createApiHook(thirdPartyTagsApiFactory);
